<div class="c-card c-content c-content--xxl">
	<div class="o-grid o-grid--center-h">
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-50@md-and-up o-grid__cell--w-40@lg-and-up u-no-p">
			<p class="c-text c-text--spaced u-osb-md">{{ 'Symptom_Check.Symptoms.Intro' | translate }}</p>
			<form name="vm.form" class="c-form">
				<div class="c-form__group u-no-m">
					<label for="symptom" class="c-form__label c-form__label--light">{{ 'Symptom_Check.Symptoms.Label' | translate }}</label>
					<input-autocomplete id="symptom" name="symptom" [(model)]="vm.symptom" [searchFn]="vm.handleSymptomSearch" [selectFn]="vm.selectSymptom" [minLength]="2" [isSmall]="true"></input-autocomplete>
				</div>
			</form>
			<ul class="c-list u-ost-md">
				<li *ngFor="let evidence of vm.interview.evidence | jsonFilter:{ source: 'initial' }" class="u-osb-sm@up-to-md">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-pl">
							<p class="c-text c-text--main">{{evidence.common_name}}</p>
						</div>
						<div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
							<button class="c-button c-button--tp c-button--icon" type="button" (click)="vm.handleSymptomRemove(evidence.id)">
								<i class="o-icon o-icon--x o-icon--sm u-no-mr" aria-hidden="true"></i>
								<span class="u-sr-only">{{ 'Common.Remove' | translate }}</span>
							</button>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="o-grid__cell o-grid__cell--center-h o-grid__cell--w-50 o-grid__cell--w-50@md-and-up o-grid__cell--w-40@lg-and-up u-no-p">
			<body-model [(interview)]="vm.interview" (selectedSymptomsChange)="vm.onSelectedSymptomsChange($event)"></body-model>
		</div>
		</div>
	<div class="o-grid u-ost-md">
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
			<button id="backButton" class="c-button c-button--link c-button--fit c-button--lg" type="button" (click)="vm.handleBack()">{{ 'Common.Back' | translate }}</button>
		</div>
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
			<button id="submitButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="button" (click)="vm.handleSubmit()">{{ 'Common.Next' | translate }}</button>
		</div>
	</div>
    <loader-overlay *ngIf="!vm.isInitialized || vm.isProcessing"></loader-overlay>
</div>
